// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function PoweredBy(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "pt-4";
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: match.branding === "Auto",
              children: React.createElement("div", {
                    "aria-hidden": true,
                    className: "text-xs text-center w-full flex justify-center " + className
                  }, React.createElement(Icon$OrcaPaymentPage.make, {
                        name: "powerd-by-hyper",
                        size: 18,
                        width: 130
                      }))
            });
}

var make = PoweredBy;

export {
  make ,
}
/* react Not a pure module */
